<ng-template #changeField let-label="label" let-change="change">
  @if (change) {
    <div class="history-entry__change">
      <span class="history-entry__change-label">{{ label }}</span>
      <span class="history-entry__change-value">
        @if (change.previous !== undefined) {
          @if (change.isDate) {
            {{ change.previous | date: 'd MMMM y, HH:mm' }} →
            {{ change.current | date: 'd MMMM y, HH:mm' }}
          } @else {
            {{ change.previous }} → {{ change.current }}
          }
        } @else {
          @if (change.isDate) {
            {{ change.current | date: 'd MMMM y, HH:mm' }}
          } @else {
            {{ change.current }}
          }
        }
      </span>
    </div>
  }
</ng-template>

<ng-template #participantList let-participants="participants">
  <div class="history-entry__participant-list">
    @for (participant of participants; track $index) {
      <div class="history-entry__participant">
        <span class="history-entry__participant-name">{{
          participant.name
        }}</span>
        @if (participant.email) {
          <span class="history-entry__participant-email c-600-grey-2">{{
            participant.email
          }}</span>
        }
      </div>
    } @empty {
      <div class="history-entry__participant">none</div>
    }
  </div>
</ng-template>

<div class="history-container">
  @for (entry of viewModel(); track entry.revisionNumber) {
    <div class="history-entry">
      <rds-avatar size="l" [disableInteractions]="true">
        <rds-icon rds-avatar-icon namespace="outlined" icon="user" />
      </rds-avatar>

      <div class="history-entry__content">
        <div class="history-entry__header">
          <span class="ui-body-m-bold">{{ entry.updatedBy }}</span>
          <span class="ui-body-s c-600-grey-2">{{
            entry.updateDate | date: 'd MMMM y, HH:mm'
          }}</span>
        </div>

        <div class="history-entry__title">
          <em>{{ entry.header }}</em>
          <span> — status: </span>
          <rds-badge
            size="s"
            type="minimal"
            [color]="entry.statusColor"
            [label]="entry.statusText" />
        </div>

        <div class="history-entry__changes">
          @for (group of entry.groups; track group.key) {
            @if (group.label) {
              <span class="history-entry__group-label">{{ group.label }}</span>
            }
            @for (field of group.fields; track field.key) {
              @if (field.participants; as participants) {
                <div class="history-entry__change history-entry__change--full">
                  <span class="history-entry__change-label">{{
                    field.label
                  }}</span>
                  <div class="history-entry__participants">
                    @if (participants.previous) {
                      <ng-container
                        *ngTemplateOutlet="
                          participantList;
                          context: { participants: participants.previous }
                        " />
                      <span class="history-entry__participants-arrow">→</span>
                    }
                    <ng-container
                      *ngTemplateOutlet="
                        participantList;
                        context: { participants: participants.current }
                      " />
                  </div>
                </div>
              } @else {
                <ng-container
                  *ngTemplateOutlet="
                    changeField;
                    context: { label: field.label, change: field.value }
                  " />
              }
            }
          }
        </div>
      </div>
    </div>
  } @empty {
    <rds-empty-state alignment="center">
      <rds-empty-state-title
        >No modifications have been made since the original
        request.</rds-empty-state-title
      >
    </rds-empty-state>
  }
</div>
